module.exports = __webpack_public_path__ + "static/box-3690e3b90b8e75bf67d9318e077de6ab.png";